(function () {
  'use strict';

  angular.module('app').component('teamMemberContactDetail', teamMemberContactDetail());

  function teamMemberContactDetail() {
    return {
      bindings: {
        item: '<',
        mode: '<',
        onSavedItem: '&',
        onCanceledItem: '&',
      },
      controller: TeamMemberContactDetailComponent,
      controllerAs: 'vm',
      templateUrl:
        './app/ajs/team-members/team-member-contacts/team-member-contact-detail/team-member-contact-detail.component.html',
    };
  }

  TeamMemberContactDetailComponent.$inject = ['UtilService', 'TeamMemberContactService'];

  function TeamMemberContactDetailComponent(UtilService, TeamMemberContactService) {
    var vm = this;

    vm.UtilService = new UtilService(vm);

    var fieldsDefinition = [
      'name',
      'last_name',
      'email',
      'relation',
      'phone_number',
      'mobile_number',
    ];

    // Methods
    vm.editTeamMemberContact = editTeamMemberContact;
    vm.saveTeamMemberContact = saveTeamMemberContact;
    vm.cancel = cancel;

    vm.$onInit = function () {
      if (vm.item.id) {
        // Edit
        setItemOptions(vm.item, vm.mode);
      } else {
        vm.createMode = true;
      }
    };

    function setItemOptions(item, mode) {
      vm.createMode = false;
      vm.editMode = false;
      vm.viewMode = true;

      if (mode === 'edit') editTeamMemberContact();

      vm.originalItem = angular.copy(item);
    }

    function editTeamMemberContact() {
      vm.editMode = true;
      vm.viewMode = false;
    }

    // Create/Update
    function saveTeamMemberContact(isFormValid) {
      vm.formErrors = false;

      if (!isFormValid) {
        vm.serverErrors = [];
        vm.formErrors = true;

        return;
      }

      if (vm.UtilService.isFormDataChanged(vm.item, vm.originalItem, fieldsDefinition)) {
        vm.sendingForm = true;
        TeamMemberContactService.saveTeamMemberContact(vm.item, vm.item.team_member_id).then(
          function (data) {
            var status = data.status;
            var response = data.response;

            if (status) {
              // Success
              vm.onSavedItem({ item: response });
            } else {
              vm.serverErrors = vm.UtilService._showItemServerErrors(response.errors);
              vm.formErrors = true;
            }

            vm.sendingForm = false;
          }
        );
      } else {
        cancel();
      }
    }

    function cancel() {
      vm.onCanceledItem();
    }
  }
})();
